<div class="s-code-status tw-flex" cropText>
  <ng-container *ngIf="statusCode; else notAvailableTemplate">
    <ng-container
      *ngTemplateOutlet="
        statusCodeItem;
        context: {
          statusCode: statusCode,
          statusDescription: statusDescription
        }
      "
    ></ng-container>
  </ng-container>
</div>

<ng-template #statusCodeItem let-statusCode="statusCode" let-statusDescription="statusDescription">
  <ui-svg-icon
    *ngIf="sCodeIcons.get(statusCode) || needEmptySpaceFoNoIconCase"
    [name]="sCodeIcons.get(statusCode)"
    class="s-code-status__icon"
  ></ui-svg-icon>
  <span class="s-code-status__description" cropText>{{ statusCode }} {{ statusDescription }}</span>
</ng-template>

<ng-template #notAvailableTemplate>
  <span class="s-code-status_not-available">
    {{ 'monitoring.transports.loadView.statusCode' | translate }}:
    {{ notAvailable }}
  </span>
</ng-template>
